import { isEqual } from 'date-fns';

import { currentBuilderState } from '../builder.state';

export function checkCacheDateParams(): void {
    const state = currentBuilderState();
    const vp = state.viewParams;

    if (vp.periodType?.id != null && vp.cacheDate?.endDate != null) {
        vp.cacheDate = state.cacheDatesMap[vp.periodType.id]?.find((e) =>
            isEqual(e.endDate, vp.cacheDate?.endDate),
        );
    }
}
